export const LIVE_KEYS = ["today", "homework", "votes", "people", "kids", "timetable"] as const;

export type LiveKey = (typeof LIVE_KEYS)[number];

export type LiveSnapshot = Record<LiveKey, string>;
